import { render, staticRenderFns } from "./PropertyAttorneys.vue?vue&type=template&id=539a225a"
import script from "./PropertyAttorneys.vue?vue&type=script&lang=js"
export * from "./PropertyAttorneys.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports